import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { TimelineLabelType } from "../../../constants/ComponentTypes";
import SendLetter from "../../Icons/SendLetter";
import FollowCall from "../../Icons/FollowCall";
import Like from "../../Icons/Like";
import Hidden from "../../Icons/Hidden";
import Dialog from "../../Icons/Dialog";
import Warning from "../../Icons/Warning";
import Thunder from "../../Icons/Thunder";
import NonConnect from "../../Icons/NonConnect";
import Connect from "../../Icons/Connect";
import SentDocument from "../../Icons/SentDocument";
import Declined from "../../Icons/Declined";

const styles = () => ({
  root: {
    width: "52px",
    height: "52px",
    minWidth: "52px",
    background: "#F2F6FF",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "18px",
  },
});

class Icon extends React.Component {
  render() {
    const { classes, status } = this.props;

    let target = Object.values(TimelineLabelType).find(label => label.value === status.status_label_type);
    if (!target) {
      target = TimelineLabelType.APPROACH;
    }

    let icon;
    let size = 24;
    const smallSize = 16
    if (target === TimelineLabelType.APPROACH && status && status.follow_call_order_address && !status.letter_order_address) {
      size = smallSize; // フォローコールのアイコンだけ24だと大きいのでサイズを指定
      icon = (<FollowCall width={size} height={size} color={target.color} />);
    } else if (target === TimelineLabelType.APPROACH
      || target === TimelineLabelType.PROOFREAD_CREATED
      || target === TimelineLabelType.ORDER_PRINTING
      || target === TimelineLabelType.ORDER_SHIPPED
    ) {
      icon = (<SendLetter width={size} height={size} color={target.color} />);
    } else if (target === TimelineLabelType.APPOINTMENT) {
      icon = (<Like width={size} height={size} color={target.color} />);
    } else if (target === TimelineLabelType.CLOSE) {
      icon = (<Hidden width={size} height={size} color={target.color} />);
    } else if (target === TimelineLabelType.APPROACH_NG) {
      icon = (<Warning width={size} height={size} color={target.color} />);
    } else if (target === TimelineLabelType.QR_CODE_REACTION) {
      icon = (<Thunder width={size} height={size} color={target.color} />);
    } else if (target === TimelineLabelType.NON_CONNECT) {
      icon = (<NonConnect width={size} height={size} color={target.color} />);
    } else if (target === TimelineLabelType.DECLINED) {
      icon = (<Declined width={size} height={size} color={target.color} />);
    } else if (target === TimelineLabelType.CONNECT) {
      icon = (<Connect width={size} height={size} color={target.color} />);
    } else if (target === TimelineLabelType.SENT_DOCUMENT) {
      icon = (<SentDocument width={size} height={size} color={target.color} />);
    } else {
      icon = (<Dialog width={size} height={size} color={target.color} />);
    }

    return (
      <div className={classes.root} style={{ backgroundColor: target.backgroundColor }}>
        {icon}
      </div>
    );
  }
}

Icon.propTypes = {
  classes: PropTypes.object.isRequired,
  status: PropTypes.object.isRequired,
};

export default withStyles(styles)(Icon);



// WEBPACK FOOTER //
// ./src/components/Timeline/atoms/Icon.jsx